<style scoped>
.tableCard {
    width: 100%;
    height: 100%;
    overflow: auto;
}
.hover-gray:hover {
    background-color: #f2f2f2; /* Remplacez cette couleur par la teinte grise souhaitée */
}
</style>

<template>
    <v-table density="compact" class="tableCard">
        <thead>
            <tr>
                <th v-for="header in tableHeaders" :style="{ color: '#154985', fontWeight:'bold' }">
                    {{ header.text }}
                </th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="(item, key) in items" :key="key" @click="handleLineClick(item)" class="hover-gray">
                <td v-for="header in tableHeaders">
                    <template v-if="header.value === 'Type de projet'">
                        <v-chip label class="ma-2" size="small" variant="elevated" color="#86B404" v-if="item[header.value]"
                            v-for="val in item[header.value].split(';#')">{{ val }}</v-chip>
                    </template>
                    <template v-else>
                        {{ item[header.value] }}
                    </template>
                </td>

            </tr>
        </tbody>
    </v-table>
</template>

<script>
import SmartTable from 'vuejs-smart-table'

export default {
    name: 'Datatable',
    props: {
        itemKey: { type: String, default: function () { return "id" } },
        headers: { type: Array, default: function () { return null } },
        items: { type: Array, default: function () { return [] } },
        lineClick: { type: Function, default: function () { return null } }
    },
    components: { SmartTable },
    data: () => ({
        height: 400,
        search: "",
    }),
    computed: {
        tableHeaders() {
            if (this.headers) {
                return this.headers;
            } else {
                if (this.items && this.items[0]) {
                    return Object.keys(this.items[0]).map((key) => {
                        return { text: key, value: key }
                    })
                } else {
                    return []
                }
            }
        },
        datas() {
            if (this.items && this.items[0]) {
                return this.items.map((item, key) => {
                    item._id = key;
                    return item
                });
            } else {
                return []
            }
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
        incomingData(newVal) {
        }
    },
    methods: {
        handleLineClick(line) {
            console.log(line)
            this.$emit("lineClick", line);
        }
    }
}
</script>
